import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
  } from "react-router-dom";

const client = Sentry.init({
	dsn: "https://f80a8bdda1f142d8b532c713d57fa0f8@errors.bridgeway.app/2",
	integrations: [
		Sentry.reactRouterV6BrowserTracingIntegration({
			useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes,
		}),
	],
	// Performance Monitoring
	tracesSampleRate: 1.0, // Capture 100% of the transactions
	tracePropagationTargets: ["localhost", /^https:\/\/bridgeway\.help/],
});
export default client;